import $ from 'jquery'
import PriseConstantes from '@/views/tableau-de-bord/dashboard-infirmier/constantes-infirmier'

export default {
    name: 'manage-constante',
    components: { PriseConstantes },
    props: {
        consultation: { type: Object, default: () => ({}) }, evolution_id: Number,
        user_id: Number, info_user: Object, modal_toggler: Number,
        selected_constant: { type: Object, default: () => ({}) },
        data_to_be_deleted: { type: Object, default: () => ({}) }, is_from_salle: Number
    },
    data() { return { prise_ouverte: false, is_error: false, permission_is_denied: false, del_loading: false, is_confirm: false } },
    watch: { modal_toggler() { this.prise_ouverte = true } },
    computed: {
        consultation_partagee() { return Object.assign({}, this.consultation, { consultation_id: this.consultation.id }) }
    },
    methods: {
        constantesEnregistrees() { this.$emit(this.is_from_salle === 0 ? 'emitConstante' : 'emitSalleCOnsultation') },
        // The existing deletion workflow is retained; no protocol route is changed.
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimerGroupMotif(selector) {
            let confirm = document.getElementById(selector);

            if (!confirm.checked) { //  Vérifie si l'utilisateur a confirmé la suppression
                $('.err-msg').fadeIn(500)
                return
            }

            this.del_loading = true

            this.$store.dispatch('deleteConsultationConstante', this.data_to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast('Constante supprimée avec succès')
                    this.$emit("emitConstante")

                    this.$refs.del_cste.click()
                } else {
                    if (response === -2) {
                        this.permission_is_denied = true
                    }
                }

                
                this.del_loading = false;
                this.is_confirm = false
                this.btn_disable = false
            }).catch(() => {
                this.del_loading = false
                this.is_error = true
            })
        }
    }
}
